import React, { useMemo } from 'react';
import {
  AutoSizer,
  List,
  ListRowRenderer,
  ScrollHandler
} from 'react-virtualized';
import LinearProgress from '@mui/material/LinearProgress';
import { LIST_ITEM_HEIGHT } from '../../../ListItemButton/overrides';

const maxVisibeOptions = 6;

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  onOptionsListScroll?: ScrollHandler;
  loading?: boolean;
  isGrouped?: boolean;
}

const ListBox = React.forwardRef<
  HTMLDivElement,
  Props
>(({ children, onOptionsListScroll, loading, isGrouped, ...props }, ref) => {

  const items = useMemo(() => {
    if (!isGrouped) return (children || []) as React.ReactElement[];
    else {
      const items: React.ReactElement[] = [];
      (children as React.ReactElement[]).forEach(
        (item: React.ReactElement & { children?: React.ReactElement[] }) => {
          const groupTitle = item.props.children[0];
          const groupItems = item.props.children[1];
          items.push(groupTitle, ...groupItems);
        },
      );
      return items;
    }
  }, [isGrouped, children]);

  const rowRenderer: ListRowRenderer = ({ key, index, style }) => (
    <div key={key} style={style}>
      {items[index]}
    </div>
  );

  const maxListHeight = LIST_ITEM_HEIGHT * maxVisibeOptions;

  const listHeight = items.length > maxVisibeOptions ?
    maxListHeight : LIST_ITEM_HEIGHT * items.length;

  return (
    <div ref={ref} {...props} style={{ height: listHeight }}>
      <AutoSizer>
        {({ width }) => {
          return <List
            width={width}
            height={listHeight}
            rowCount={items.length}
            rowHeight={LIST_ITEM_HEIGHT}
            rowRenderer={rowRenderer}
            onScroll={onOptionsListScroll}
          />;
        }}
      </AutoSizer>
      {loading && <LinearProgress />}
    </div>
  );
});

export default ListBox;